import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Icon } from '../../../components/common';
const CheckboxControl = ({ label, options, onChange, defaultSelections, }) => {
    const [selections, setSelections] = useState(defaultSelections);
    const onSelect = (value) => {
        if (!selections.includes(value)) {
            setSelections([...selections, value]);
        }
        else {
            const newSelections = selections.filter((item) => item !== value);
            setSelections(newSelections);
        }
    };
    useEffect(() => {
        onChange(selections);
    }, [selections]);
    return (_jsx("div", { className: "leaflet-top leaflet-right mt-9 mr-9", children: _jsx("div", { className: "leaflet-control !cursor-pointer", children: _jsxs("div", { className: "grid gap-y-2 rounded border-2 border-black/25 m-3 p-2 bg-white overflow-auto", children: [label &&
                        (_jsx("div", { className: "text-sm", children: label })), options.map((thisOption) => {
                        return (_jsxs("div", { onClick: () => onSelect(thisOption.value), className: "flex gap-x-2 justify-start", children: [selections.includes(thisOption.value) ?
                                    _jsx(Icon, { icon: "checkBoxSelected", className: "w-4 h-4 text-aptivegreen inline" })
                                    :
                                        _jsx(Icon, { icon: "checkBoxUnselected", className: "w-4 h-4 text-gray-600 inline" }), thisOption.label] }, thisOption.value));
                    })] }) }) }));
};
export default CheckboxControl;
